"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);
    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
  }

  (0, _createClass3.default)(Header, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container header" },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-2 col-sm-3 header-left-col" },
            _react2.default.createElement("i", {
              className: "icon-mp-bars header-button-menu",
              "aria-hidden": "true",
              onClick: this.props.toggle
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-8 col-sm-6" },
            _react2.default.createElement(
              "div",
              { className: "header-logo" },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/" },
                _react2.default.createElement("img", { src: "/img/maaporssi-logo-text-white.png" })
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-2 col-sm-3 header-button-user" },
            this.renderIcon()
          )
        )
      );
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var _props = this.props,
          user = _props.user,
          register = _props.register,
          logout = _props.logout;

      if (!user) {
        return _react2.default.createElement(
          "div",
          { className: "header-button-container", onClick: register },
          _react2.default.createElement(
            "span",
            { className: "header-button-text" },
            "Rekister\xF6idy"
          ),
          _react2.default.createElement("i", { className: "icon-mp-user", "aria-hidden": "true" })
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "header-button-container", onClick: logout },
        _react2.default.createElement(
          "span",
          { className: "header-button-text" },
          user.email
        ),
        _react2.default.createElement("i", { className: "icon-mp-logout", "aria-hidden": "true" })
      );
    }
  }]);
  return Header;
}(_react.Component), _class.propTypes = {
  toggle: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object,
  logout: _react.PropTypes.func.isRequired,
  register: _react.PropTypes.func.isRequired
}, _temp);
exports.default = Header;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header.js
 ** module id = 1144
 ** module chunks = 0
 **/